export default __webpack_public_path__ + "static/media/file_grid.b7c46b5f.svg";